const freelancers = [
  {
    slug: "marinke-callens",
    name: "Marinke Callens",
    role_en: "Industrial & Graphic Designer",
    role_pt: "Designer Industrial e Gráfica",
    short_en: "Industrial designer combining creative and technical expertise across product, branding and manufacturing.",
    short_pt: "Designer industrial que combina criatividade e conhecimento técnico em produto, branding e produção.",
    description_en: "I'm an industrial and graphic designer based in Ericeira...",
    description_pt: "Sou designer industrial e gráfica, baseada na Ericeira...",
    avatar: "/images/freelancers/marinke.webp",
    what_en: [
      "Product & industrial design",
      "Brand identity and visual systems",
      "Packaging and print design",
      "Design for manufacturing & prototyping"
    ],
    what_pt: [
      "Design de produto e industrial",
      "Identidade de marca e sistemas visuais",
      "Embalagem e design gráfico",
      "Design para produção e prototipagem"
    ],
    selected_work_en: [
      {
        label: "Website for a portuguese artist",
        url: "https://joaquimalves.pt"
      },
      {
        label: "Website for Espinho Polytechnic Institute",
        url: "https://www.ipespinho.com"
      },
      {
        label: "Website for a video recommendation technology company (Spideo)",
        url: "https://spideo.com"
      }
    ],
    selected_work_en: [
      {
        label: "Site para arista português",
        url: "https://exemplo-artist.com"
      },
      {
        label: "Booking site for a surf school",
        url: "https://exemplo-surf.com"
      },
      {
        label: "Portfolio site for a visual artist",
        url: "https://exemplo-portfolio.com"
      }
    ],
    website: "https://www.marinke.be",
    email: "design@marinke.be",
    phone: ""
  },
  {
    slug: "filippo-galli",
    name: "Filippo Galli",
    role_en: "AI & Automation Consultant",
    role_pt: "Consultor de IA e Automação",
    short_en: "Helping small and medium businesses automate processes and leverage AI.",
    short_pt: "Ajudo pequenas e médias empresas a automatizar processos e a tirar partido da IA.",
    description_en: "I work with small and medium businesses to remove repetitive work through automation and practical AI. From internal tools to customer-facing assistants, I focus on what actually saves time and money.",
    description_pt: "Trabalho com pequenas e médias empresas para eliminar tarefas repetitivas através de automação e IA prática. De ferramentas internas a assistentes para clientes, foco-me no que realmente poupa tempo e dinheiro.",
    avatar: "/images/freelancers/filippo-galli.webp",
    what_en: [
      "Business process automation",
      "Custom AI assistants & chatbots",
      "Workflow integrations (Zapier, Make, n8n)",
      "AI strategy for small teams"
    ],
    what_pt: [
      "Automação de processos de negócio",
      "Assistentes de IA e chatbots personalizados",
      "Integrações de fluxo de trabalho (Zapier, Make, n8n)",
      "Estratégia de IA para equipas pequenas"
    ],
    selected_work_en: [
      {
        label: "Website for a portuguese artist",
        url: "https://joaquimalves.pt"
      },
      {
        label: "Website for Espinho Polytechnic Institute",
        url: "https://www.ipespinho.com"
      },
      {
        label: "Website for a video recommendation technology company (Spideo)",
        url: "https://spideo.com"
      }
    ],
    selected_work_en: [
      {
        label: "Site para arista português",
        url: "https://exemplo-artist.com"
      },
      {
        label: "Booking site for a surf school",
        url: "https://exemplo-surf.com"
      },
      {
        label: "Portfolio site for a visual artist",
        url: "https://exemplo-portfolio.com"
      }
    ],
    website: "https://easycustom.tech",
    email: "filippo@easycustom.tech",
    phone: "+351965879961"
  },
  {
    slug: "diogo-henriques",
    name: "Diogo Henriques",
    role_en: "Web Designer & Developer",
    role_pt: "Web Designer e Developer",
    short_en: "Designing and building simple, fast and effective websites for small businesses.",
    short_pt: "Desenho e construo sites simples, rápidos e eficazes para pequenos negócios.",
    description_en: "I design and build websites for small businesses that want a clean, honest online presence. My focus is clarity, speed, and making sure the site actually does something for the business — not just look nice.",
    description_pt: "Desenho e construo sites para pequenos negócios que querem uma presença online clara e honesta. Foco-me em clareza, velocidade e garantir que o site faz algo pelo negócio — não apenas parecer bonito.",
    avatar: "/images/freelancers/DiogoHenriques-ericeira-works.webp",
    what_en: [
      "Website design & development",
      "Landing pages for small businesses",
      "Web performance & SEO basics",
      "Simple content management setups"
    ],
    what_pt: [
      "Design e desenvolvimento web",
      "Landing pages para pequenos negócios",
      "Performance web e SEO essencial",
      "Gestão de conteúdos simples"
    ],
    selected_work_en: [
      {
        title: "Website for the Polytechnic Institute of Espinho",
        subtitle: "Institutional website with a clearer and more modern structure.",
        url: "https://www.ipespinho.com/",
        image: "/images/freelancers/work/diogo-ipespinho.webp"
      },
      {
        title: "Video recommendation technology platform",
        subtitle: "Clearer positioning for a complex tech product.",
        url: "https://spideo.com",
        image: "/images/freelancers/work/diogo-spideo.webp"
      },
      {
        title: "Portuguese artist portfolio",
        subtitle: "Portfolio website focused on simplicity and atmosphere.",
        url: "https://joaquimalves.pt/",
        image: "/images/freelancers/work/diogo-joaquimalves.webp"
      }
    ],
    selected_work_pt: [
      {
        label: "Site para arista português",
        url: "https://exemplo-artist.com"
      },
      {
        label: "Booking site for a surf school",
        url: "https://exemplo-surf.com"
      },
      {
        label: "Portfolio site for a visual artist",
        url: "https://exemplo-portfolio.com"
      }
    ],
    website: "https://diogoh.pt/",
    email: "info@diogoh.pt",
    phone: "911739498"
  }
];

export default freelancers;